export default "<p>passengers works!</p>\n";